/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable @typescript-eslint/no-unsafe-type-assertion */
import type { JSX } from 'react';

import type { TranslationKey } from '@change-corgi/core/i18n';

import { useSharingTools } from '../../../../hooks/useSharingTools';
import { SharingToolsCardWrapperVariant2 } from '../../../SharingToolsCardWrapper/variant2';
import { SocialContentPreview } from '../SocialContentPreview';

export function SocialContentCard(): JSX.Element {
	const { data, actions } = useSharingTools();
	return (
		<SharingToolsCardWrapperVariant2
			Preview={<SocialContentPreview isLoading={data.shareVisual.isLoading} shareVisual={data.shareVisual.image} />}
			titleKey={'corgi.petition.starter_dashboard_v2.sharing_tools.social_content.title' as unknown as TranslationKey}
			descriptionKey={
				'corgi.petition.starter_dashboard_v2.sharing_tools.social_content.description' as unknown as TranslationKey
			}
			primaryActionTextKey={
				'corgi.petition.starter_dashboard_v2.sharing_tools.social_content.primary_action_text' as unknown as TranslationKey
			}
			primaryActionOnClick={actions.navigateToShareVisual}
		/>
	);
}
